import Image from 'next/image';

export const MapGiftImage = () => {
    return (
        <Image
            src="/assets/map-gift.png"
            unoptimized={true}
            width={128}
            height={146.53}
            alt='Map Gift Illustration'
        />
    );
};
